import React from 'react';
import styled from 'styled-components';

import { Flex } from '../components/common/atom/Layout';
import FloatingButton from '../components/common/molecules/FloatingButton';
import { SubHeader } from '../components/common/organism/SubHeader';
import Header from '../components/common/organism/Header';
import PCLeftBanner from '../components/common/organism/PCLeftBanner';
import PCBackground from '../components/common/organism/PCBackground';

import { breakpoint, SizeToRem } from '../lib/style/ThemeStyle';

const BlogPage = () => {
  return (
    <>
      <Page>
        <PCBackground />
        <PCLeftBanner />
        <MainContainer role="main">
          <Header />
          <SubHeader title={PAGE_TITLE} />
          <PageLayout noMargin withSubTitle={PAGE_TITLE}>
            <EmbededIframe src="https://babyface.oopy.io/" title={PAGE_TITLE} />
          </PageLayout>
        </MainContainer>
        <FloatingButton />
      </Page>
    </>
  );
};

export default BlogPage;

const PAGE_TITLE = '블로그';

const EmbededIframe = styled.iframe`
  display: block;
  width: 100%;
  height: calc(100vh - 127px);
  border: none;
`

const Page = styled(Flex)`
  background: #fcf6f9;
`;

const MainContainer = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: ${breakpoint}px;
  min-height: 100vh;
  background: ${({ theme }) => theme.background.white};
  z-index: 1;
`;

const PageLayout = styled.section`
  width: inherit;
  background: #ffffff;
  margin-top: ${(props) => (!props.withSubTitle ? '2.875rem' : '5.625rem')};
  padding: ${(props) => (props.noMargin ? 0 : SizeToRem(20))};
`;
